import type { RouteRecordName } from 'vue-router'

import { MarketCountryCode } from '@backmarket/http-api'
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

import { trackWebPerformanceAll as sendAmplitudeWebPerformanceEvent } from './amplitude/events'
import {
  trackWebPerformance as sendNoodleWebPerformanceEvent,
  trackRumView,
} from './noodle/events'
import type { PageViewData } from './types'

function getConnection() {
  if (!process.client) {
    return 'unknown'
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType
  return window.navigator?.connection?.effectiveType || 'unknown'
}

function getDeviceType() {
  // only works on client side, so we are mobile first on server side
  if (!process.client) {
    return 'mobile'
  }

  // TODO [FRONT-827] This need to be shared between modules.
  const breakpoints = [
    '(min-width: 992px)',
    '(min-width: 768px)',
    '(min-width: 480px)',
    '(max-width: 480px)',
  ]

  const matchMedia = (media: string) => window.matchMedia(media).matches
  const breakpoint = breakpoints.length - breakpoints.findIndex(matchMedia) - 1

  return breakpoint < 2 ? 'mobile' : 'desktop'
}

function startMonitoringWebVitals(details: PageViewData) {
  onCLS(({ value }) =>
    sendNoodleWebPerformanceEvent({
      ...details,
      metric: 'cls',
      value,
    }),
  )

  onFCP(({ value }) =>
    sendNoodleWebPerformanceEvent({
      ...details,
      metric: 'fcp',
      value,
    }),
  )

  onLCP(({ value }) =>
    sendNoodleWebPerformanceEvent({
      ...details,
      metric: 'lcp',
      value,
    }),
  )

  onTTFB(({ value }) =>
    sendNoodleWebPerformanceEvent({
      ...details,
      metric: 'ttfb',
      value,
    }),
  )

  onINP(({ value }) => {
    sendNoodleWebPerformanceEvent({
      ...details,
      metric: 'inp',
      value,
    })

    sendAmplitudeWebPerformanceEvent({
      ...details,
      metric: 'inp',
      value,
    })
  })
}

export function initWebVitals({
  routeName,
  country,
}: {
  routeName: RouteRecordName
  country: MarketCountryCode
}) {
  const connection = getConnection()
  const deviceType = getDeviceType()

  const data = {
    pageType: String(routeName),
    connection,
    deviceType,
    country,
  }

  startMonitoringWebVitals(data)
  trackRumView(data)
}
